'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import PaymentSuccess from 'Components/Front/PaymentSuccess';
import StripeForm from 'Components/Front/StripeForm';
import TextInput from 'Components/Forms/Elements/TextInput';
import Image from 'Pure/Image';
import CheckedIcon from 'Icons/Checked';
import bemit from 'Functions/bemit';
import { safeNumeral, formatNum } from 'Shared/utilities';
const {
  app,
  qwest
} = window;
export default class BuyPacksPage extends Component {
  state = {
    status_messages: {},
    step: 0,
    card_modal: false,
    order_form_modal: false
  };
  handleChange = handleChange.bind(this);
  card_modal_ref = React.createRef();
  order_form_modal_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPack();
  }
  fetchPack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/pack/get-all', {
      display_status: "true",
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        packs: response.data,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  pickPack = (e, pack_id) => {
    const component = this,
      props = this.props,
      state = this.state;
    e?.persist();
    const pack = state.packs.find(data => data.id === pack_id);
    if (pack) {
      app.emit({
        event: 'TC_Click',
        source: 'BuyPacksPage',
        data: {
          e: e,
          action: 'choix_pack_' + formatNum(pack.credit_amount, '0')
        }
      });
    }
    component.setState({
      step: 1,
      ['packorder[' + pack_id + '][quantity]']: 1
    });
  };
  addQuantity = (e, pack_id) => {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    const value = numeral(safeNumeral(state['packorder[' + pack_id + '][quantity]'])).add(1).format('0');
    component.setState({
      ['packorder[' + pack_id + '][quantity]']: value
    });
    e?.persist();
    app.emit({
      event: 'TC_Click',
      source: 'BuyPacksPage',
      data: {
        e: e,
        action: 'quantite_pack'
      }
    });
  };
  removeQuantity = (e, pack_id) => {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    if (state['packorder[' + pack_id + '][quantity]'] === "0" || state['packorder[' + pack_id + '][quantity]'] === "") return;
    const value = numeral(safeNumeral(state['packorder[' + pack_id + '][quantity]'])).subtract(1).format('0');
    component.setState({
      ['packorder[' + pack_id + '][quantity]']: value
    });
    e?.persist();
    app.emit({
      event: 'TC_Click',
      source: 'BuyPacksPage',
      data: {
        e: e,
        action: 'quantite_pack'
      }
    });
  };
  paymentByOrderForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.closeOrderFormModal();
    app.emit({
      event: 'TC_Click',
      source: 'BuyPacksPage',
      data: {
        e: undefined,
        action: 'paiement_pack'
      }
    });
    const packorder = getFormData({
      state: state,
      pattern: 'packorder['
    });
    qwest.post('/packorder/payment-by-order-form', packorder).then(function (xhr, response) {
      const packs_reset = {};
      (state.packs || []).filter(pack => pack && pack.id).forEach(function (pack) {
        packs_reset['packorder[' + pack.id + '][quantity]'] = '';
      });
      component.setState({
        ...packs_reset,
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  paymentByCard = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.closeCardModal();
    const packorder = getFormData({
      state: state,
      pattern: 'packorder['
    });
    qwest.post('/packorder/payment-by-card', packorder).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        packorder: response.packorder,
        step: 2,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  openCardModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      card_modal: true,
      card_modal_trg: e?.target
    });
  };
  closeCardModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      card_modal: false,
      card_modal_trg: undefined
    });
  };
  openOrderFormModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      order_form_modal: true,
      order_form_modal_trg: e?.target
    });
  };
  closeOrderFormModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      order_form_modal: false,
      order_form_modal_trg: undefined
    });
  };
  handlePaymentFail = ({
    error,
    error_type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      packorder: undefined,
      error: error
    });
  };
  prevStep = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      step: state.step - 1
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    if (state.step === 'cc-payment-success') {
      return /*#__PURE__*/React.createElement(Layout, _extends({
        page_title: "Acheter des packs"
      }, props), /*#__PURE__*/React.createElement("div", {
        className: "o-content dashboard-page u-padding-right-0"
      }, /*#__PURE__*/React.createElement(PaymentSuccess, {
        "hide-home-button": true
      })));
    }
    const payment_form = state.step === 2 && state.packorder?.id && state.packorder?.payment_type === 'card' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: 'u-margin-left-15 u-margin-bottom-10 ' + bemit('c-flat-btn', ['primary']),
      onClick: component.prevStep
    }, "Retour"), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement(StripeForm, {
      packorder: state.packorder,
      prevStep: component.prevStep,
      onSuccess: () => component.setState({
        step: 'cc-payment-success'
      }),
      bemit: ['back']
    }))) : undefined;
    let packs_row = (state.packs || []).map(function (pack) {
      let amount = numeral(state['packorder[' + pack.id + '][quantity]'] || 0).multiply(pack.credit_amount).multiply(pack.amount).format('0.00');
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__row",
        key: pack.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.title), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell pack-order-qty"
      }, /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-btn', ['less']) + ' u-margin-right-10',
        onClick: e => component.removeQuantity(e, pack.id)
      }, "- 1"), /*#__PURE__*/React.createElement(TextInput, {
        className: "pack-order__input u-full-width",
        name: 'packorder[' + pack.id + '][quantity]',
        onChange: component.handleChange,
        value: state['packorder[' + pack.id + '][quantity]'],
        id: state.people_id,
        status: state.status_messages,
        "safe-value": true,
        int: true,
        inputMode: "numeric",
        min: "1"
      }), /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-btn', ['more']) + ' u-margin-left-10',
        onClick: e => component.addQuantity(e, pack.id)
      }, "+ 1")), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.credit_amount), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, amount, "\u20AC"), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.duration, " j"));
      return output;
    });
    const chosen_pack = Object.keys(state).filter(key => key.startsWith('packorder[')).map(function (pack) {
      const pack_id = pack.split('[')[1].split(']')[0];
      const current_pack = state.packs.find(pack => pack.id === pack_id);
      const quantity = state[pack];
      if (!current_pack || quantity === 0 || quantity === "0" || quantity === "") return;
      const amount = numeral(current_pack.credit_amount).multiply(current_pack.amount).multiply(quantity).format('0.00');
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-back-recap__item"
      }, quantity, " x ", current_pack.title, " - ", current_pack.credit_amount, " cr\xE9dits - ", amount, "\u20AC HT soit ", current_pack.amount, "\u20AC HT par cr\xE9dit");
      return output;
    });
    let packs = (state.packs || []).map(function (pack) {
      let amount = numeral(pack.credit_amount).multiply(pack.amount).format('0.00');
      let month_duration = moment().add(pack.duration, 'days').diff(moment(), 'months');
      let output = /*#__PURE__*/React.createElement("div", {
        key: pack.id,
        className: "c-pack-list__grid-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-credits"
      }, pack.credit_amount, " H", /*#__PURE__*/React.createElement("span", null, "soit ", pack.credit_amount, " cr\xE9dits")), /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-title"
      }, pack.title, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: "c-pack-list__grid-item-duration"
      }, "Validit\xE9 : ", month_duration, " mois")), /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-description"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "c-pack-list__grid-item-ul"
      }, /*#__PURE__*/React.createElement("li", null, "Acc\xE8s aux 2 types d'espace de coworking myWO :", /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Espace Lounge, calme et isol\xE9, r\xE9servable en ligne"), /*#__PURE__*/React.createElement("li", null, "Espace Lib accessible sans r\xE9servation (sous r\xE9serve de places et de consommation)."))), /*#__PURE__*/React.createElement("li", null, "60 espaces en France d'ici fin 2021"), /*#__PURE__*/React.createElement("li", null, "Welcome drink en myWO Lounge (fontaine \xE0 eau, cocktail d\xE9tox...)"), /*#__PURE__*/React.createElement("li", null, "-10% sur les consommations en Lib' et Lounge"))), /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-flat-btn', ['blue', 'pack']),
        onClick: e => component.pickPack(e, pack.id)
      }, "Choisir ce pack"), /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-total"
      }, "Tarif\xA0: ", /*#__PURE__*/React.createElement("span", {
        className: "c-pack-list__grid-item-price"
      }, amount, "\u20AC\xA0HT"), " soit ", pack.amount, "\u20AC HT par cr\xE9dit"));
      return output;
    });
    const pack_form = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: 'u-margin-left-15 u-margin-bottom-10 ' + bemit('c-flat-btn', ['primary']),
      onClick: component.prevStep
    }, "Retour"), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-dashboard', ['head'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Pack"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Quantit\xE9"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Nombre de cr\xE9dit"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Tarif HT"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Dur\xE9e de consommation"))), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-dashboard')
    }, packs_row)))), /*#__PURE__*/React.createElement("div", {
      className: "o-content u-text-center"
    }, status, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.openOrderFormModal
    }, "Paiement par bon de commande"), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']) + ' u-margin-left-5',
      onClick: component.openCardModal
    }, "Paiement par carte bancaire")));
    const packs_list = /*#__PURE__*/React.createElement("div", {
      className: "o-content c-pack-list"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__presentation"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__presentation-col"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Le bon choix en fonction de vos besoins")), /*#__PURE__*/React.createElement("p", null, "Start-up ou entreprise, payez ce dont vous avez besoin. ", /*#__PURE__*/React.createElement("br", null), "myWO vous propose des formules sur-mesure")), /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__presentation-col"
    }, /*#__PURE__*/React.createElement(Image, {
      src: "/images/packs.jpg",
      className: "c-pack-list__presentation-col-image"
    }))), /*#__PURE__*/React.createElement("strong", null, "Les formules"), /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__grid"
    }, packs));
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Acheter des packs"
    }, props), state.step === 1 ? pack_form : state.step === 2 ? payment_form : packs_list, /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.card_modal,
      title: "R\xE9capitulatif de votre commande",
      trigger_src: state.card_modal_trigger,
      "close-ref": component.card_modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeCardModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-back-recap"
    }, chosen_pack), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.paymentByCard
    }, "Valider ma commande"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.card_modal_ref?.current?.click()
    }, "Annuler"))), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.order_form_modal,
      title: "R\xE9capitulatif de votre commande",
      trigger_src: state.order_form_modal_trg,
      "close-ref": component.order_form_modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeOrderFormModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-back-recap"
    }, chosen_pack), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.paymentByOrderForm
    }, "Valider ma commande"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.order_form_modal_ref?.current?.click()
    }, "Annuler"))));
    return output;
  }
}
